import React from "react";
import "../styles/Footer.css";

function Footer() {
  return (
    <footer className="blockquote-footer">
      <p>
        Application développée par{" "}
        <a
          href="https://www.ab-developpement.fr/"
          target="_blank"
          rel="noreferrer"
        >
          Yacine Développeur
        </a>
      </p>
    </footer>
  );
}

export default Footer;
